import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { Container, Eyebrow, Heading } from '../components/ui/Section';
import { CtaBand } from '../components/ui/CtaBand';
import { CaseStudyFramework, ClientLogosCarousel, ProofStats } from '../components/features/ClientsProof';
import { IMAGES } from '../data/solutions';
import { useSeo } from '../utils/seo';
const CRUMBS = [{
  name: 'Inicio',
  path: '/'
}, {
  name: 'Clientes',
  path: '/clientes'
}];
export function Clients() {
  useSeo({
    title: 'Clientes y experiencia | Operador logístico y de servicios — Rabemar',
    description: 'Experiencia en operaciones logísticas, Facility Management y HSE para empresas en Argentina. Clientes, casos e indicadores publicados únicamente con validación de la empresa.',
    path: '/clientes',
    image: IMAGES.team,
    breadcrumbs: CRUMBS
  });
  return <>
      <PageHero eyebrow="Clientes y experiencia" title="Operaciones que se sostienen en el tiempo." lead="Trabajamos con empresas que necesitan continuidad, cumplimiento y trazabilidad. Publicamos únicamente clientes, casos e indicadores verificados." image={IMAGES.team} imageAlt="Equipo de operaciones de Rabemar en el área de muelles de un centro de distribución" crumbs={CRUMBS} ctaLabel="Solicitar propuesta" data-id="element-535" data-mp="2as794dghjejh" />

      <section className="bg-white py-20 md:py-28" data-id="element-536" data-mp="3qh77l9w9i9kk">
        <Container data-id="element-537" data-mp="2tuby5yepzgls">
          <div className="grid gap-12 lg:grid-cols-[1fr_1fr] lg:gap-20" data-id="element-538" data-mp="2tuu5pr6u1h90">
            <div data-id="element-539" data-mp="2ytf5xqm340xg">
              <Eyebrow data-id="element-540" data-mp="2ysvmu6kp76hu">Indicadores informados</Eyebrow>
              <Heading as="h2" size="md" className="mt-5" data-id="element-541" data-mp="32u7f6juyi5tq">
                Trayectoria medida, no declamada.
              </Heading>
              <p className="mt-5 text-lg leading-relaxed text-graphite-500" data-id="element-542" data-mp="37lh4fjclf753">
                Los indicadores que figuran en la presentación corporativa quedan visibles para el equipo comercial y se
                publican una vez confirmados. Ningún número se incorpora al sitio sin respaldo.
              </p>
            </div>
            <ProofStats data-id="element-543" data-mp="3id7gkxgvrpr0" />
          </div>

          <div className="mt-16 border-t border-mist-200 pt-12" data-id="element-544" data-mp="3dgphad4bkjm2">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-graphite-500" data-id="element-545" data-mp="3ded0426dyda2">Clientes</p>
            <div className="mt-6" data-id="element-546" data-mp="3s6wry6o34yc7">
              <ClientLogosCarousel data-id="element-547" data-mp="3n5quxwne6owv" />
            </div>
            <p className="mt-6 max-w-3xl text-sm leading-relaxed text-graphite-500" data-id="element-548" data-mp="3n8d0jqqq2ucg">
              Los espacios de logotipos se completan exclusivamente con los clientes confirmados en la presentación
              corporativa de Rabemar. No se publican marcas sin autorización ni referencias no verificables.
            </p>
          </div>
        </Container>
      </section>

      <section className="bg-graphite-900 py-20 md:py-28" data-id="element-549" data-mp="34dy3w7rvvdrs">
        <Container data-id="element-550" data-mp="nqc9h8vtu6wi">
          <div className="max-w-3xl" data-id="element-551" data-mp="npkgm5tm6n9x">
            <Eyebrow tone="dark" data-id="element-552" data-mp="nsq6hna2ht6p">Casos de éxito</Eyebrow>
            <Heading as="h2" size="md" tone="dark" className="mt-5" data-id="element-553" data-mp="jo8qlz6tw017">
              Cómo publicamos un caso.
            </Heading>
            <p className="mt-5 text-base leading-relaxed text-mist-200" data-id="element-554" data-mp="raw0ev4ftxv2">
              Todos los casos siguen la misma estructura, para que el lector pueda comparar situaciones equivalentes y
              entender qué cambió realmente en la operación.
            </p>
          </div>
          <div className="mt-12" data-id="element-555" data-mp="ma89e9g7lh0u">
            <CaseStudyFramework data-id="element-556" data-mp="19zaqng6xl7ut" />
          </div>
        </Container>
      </section>

      <CtaBand title="¿Quiere referencias de una operación como la suya?" text="El equipo comercial puede compartir referencias del sector y el detalle del alcance gestionado, con la autorización correspondiente." primaryLabel="Hablar con un especialista" secondaryLabel="Solicitar propuesta" location="clientes-cta" data-id="element-557" data-mp="1a1do2laey39k" />
    </>;
}